module.exports = __webpack_public_path__ + "static/media/siddharth-salem-trip-02.795fc8f8.png";